var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.16666L3.56667 2.34333C3.69527 2.04333 3.90913 1.78769 4.18171 1.60815C4.45429 1.4286 4.7736 1.33304 5.1 1.33333H12.9017C13.2278 1.33336 13.5467 1.42908 13.819 1.6086C14.0912 1.78813 14.3048 2.04359 14.4333 2.34333L16.5 7.16666M1.5 7.16666H16.5M1.5 7.16666V13M16.5 7.16666V13M14 13V13.4167C14 13.7482 14.1317 14.0661 14.3661 14.3005C14.6005 14.535 14.9185 14.6667 15.25 14.6667C15.5815 14.6667 15.8995 14.535 16.1339 14.3005C16.3683 14.0661 16.5 13.7482 16.5 13.4167V13M14 13H4M14 13H16.5M4 13V13.4167C4 13.7482 3.8683 14.0661 3.63388 14.3005C3.39946 14.535 3.08152 14.6667 2.75 14.6667C2.41848 14.6667 2.10054 14.535 1.86612 14.3005C1.6317 14.0661 1.5 13.7482 1.5 13.4167V13M4 13H1.5",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 7.16666H16.5V13H1.5V7.16666ZM4 9.66666C4 9.44564 4.0878 9.23368 4.24408 9.0774C4.40036 8.92112 4.61232 8.83332 4.83333 8.83332H4.83417C5.05518 8.83332 5.26714 8.92112 5.42342 9.0774C5.5797 9.23368 5.6675 9.44564 5.6675 9.66666C5.6675 9.88767 5.5797 10.0996 5.42342 10.2559C5.26714 10.4122 5.05518 10.5 4.83417 10.5H4.83333C4.61232 10.5 4.40036 10.4122 4.24408 10.2559C4.0878 10.0996 4 9.88767 4 9.66666ZM13.1667 8.83332C12.9457 8.83332 12.7337 8.92112 12.5774 9.0774C12.4211 9.23368 12.3333 9.44564 12.3333 9.66666C12.3333 9.88767 12.4211 10.0996 12.5774 10.2559C12.7337 10.4122 12.9457 10.5 13.1667 10.5H13.1675C13.3885 10.5 13.6005 10.4122 13.7568 10.2559C13.913 10.0996 14.0008 9.88767 14.0008 9.66666C14.0008 9.44564 13.913 9.23368 13.7568 9.0774C13.6005 8.92112 13.3885 8.83332 13.1675 8.83332H13.1667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.e377450688ffc78e828e3b6ded9f1be6.svg";
export { ForwardRef as ReactComponent };